export default function EventosPage() {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">🎉 Eventos y Festividades</h1>
      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-600">
          Módulo de eventos y festividades hebreas en desarrollo.
        </p>
      </div>
    </div>
  );
}






